import 'focus-visible';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange'; // tslint:disable-line
import 'lazysizes/plugins/respimg/ls.respimg'; // tslint:disable-line
import 'lazysizes/plugins/rias/ls.rias'; // tslint:disable-line
import '../sections/product-slider';

import '../../styles/theme.pcss';

import {CartLink} from '../ui/cart-link';
import '../ui/cart-link/cart-link.pcss';

import {Dropdown} from '../ui/dropdown';
import '../ui/dropdown/dropdown.pcss';

import {Navigation} from '../ui/navigation';
import '../ui/navigation/navigation.pcss';

import {ProductCard} from '../ui/product-card';
import '../ui/product-card/product-card.pcss';

import {StickyHeader} from '../ui/sticky-header';
import '../ui/sticky-header/sticky-header.pcss';

import {NewsletterPopup} from '../ui/newsletter-popup';
import '../ui/newsletter-popup/newsletter-popup.pcss';

import {PlusMinus} from '../ui/plus-minus';
import '../ui/plus-minus/plus-minus.pcss';

import {SearchBox} from '../ui/search-box';
import '../ui/search-box/search-box.pcss';

import {cookiesEnabled, mountReact, ready} from '../utils';

import {MessageGroup} from '../ui/message-group';
import {MiniCart} from '../ui/mini-cart';
import '../ui/usp-banner';

if (!cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-cookies',
    'supports-no-cookies',
  );
}

const nav = document.querySelector('[data-navigation]') as HTMLElement;
new Navigation(nav);

const stickyheader = document.querySelector(
  '[data-stickyheader]',
) as HTMLElement;
new StickyHeader(stickyheader);

const newsletterContainer = document.querySelector(
  NewsletterPopup.defaults.container,
) as HTMLElement;
new NewsletterPopup(newsletterContainer);

new ProductCard();

Array.from(document.querySelectorAll(CartLink.defaults.selector)).map(
  item => new CartLink(item as HTMLElement),
);

Array.from(document.querySelectorAll(Dropdown.defaults.selector)).map(
  item => new Dropdown(item as HTMLElement),
);

Array.from(document.querySelectorAll(PlusMinus.defaults.selector)).map(
  item => new PlusMinus(item as HTMLElement),
);

Array.from(document.querySelectorAll(SearchBox.defaults.selector)).map(
  item => new SearchBox(item as HTMLElement),
);

mountReact('#message-group', MessageGroup);
mountReact('#mini-cart', MiniCart);

/**
 * DOM loaded decorator for animation fix
 */
const removePreload = () => document.body.classList.remove('preload');

ready(removePreload);

/**
 * Decorate lazy load parents
 * @param {Event} event
 */
function decorateLazyParent(event: Event) {
  const target = event.target as HTMLElement;
  const wrapper = target.closest('.responsive-image__wrapper');

  if (!wrapper) {
    return;
  }

  wrapper.classList.add('has-loaded');
}

document.addEventListener('lazyloaded', decorateLazyParent);

declare global {
  interface Window {
    theme: {
      moneyFormat: string;
    };
  }
}
